// ID11 · clasificación PURA de la disponibilidad de audio del caso para presentarla sin inventar
// estados. Entrada: `recursos_disponibles` del read-model (o su proyección externa) y el estado del
// caso. No consulta nada, no inicia audio y no afirma audio físico.
//
//   disponible   · el preflight dijo que sí.
//   no_aplica    · caso cerrado: el preflight se detiene en «no tomado» y no comprobó el equipo.
//   no_disponible· el preflight dijo que no y declaró su motivo. `categoria` separa lo que SÍ
//                  comprobó (no_instalado / temporal) de lo que NO llegó a comprobar (sin_comprobar).
//   no_informado · el dato no llegó (campo ausente, motivo vacío o no reconocido). Nunca es un NO.

export const MOTIVOS_NO_INSTALADO = new Set(["SIN_DISPOSITIVO_AUDIO", "AUDIO_NO_COMMISSIONED", "CONSENTIMIENTO_FALTANTE"]);
// El preflight sale ANTES de buscar el equipo: no consta si el audio está instalado.
export const MOTIVOS_SIN_COMPROBAR = new Set(["CASO_NO_ENCONTRADO", "CASO_NO_TOMADO", "NO_AUTORIZADO", "PERSONA_AMBIGUA"]);
export const MOTIVOS_TEMPORALES = new Set(["DISPOSITIVO_AUDIO_AMBIGUO", "SIP_OFFLINE", "SIP_NO_CONFIRMADO", "AUDIO_DEVICE_BUSY"]);

export function estadoAudio(rec, estadoCaso) {
  const r = rec || {};
  if (typeof r.audio !== "boolean") return { estado: "no_informado", motivo: null, categoria: null };
  if (r.audio === true) return { estado: "disponible", motivo: r.audio_motivo || "OK", categoria: null };
  const motivo = r.audio_motivo || null;
  if (estadoCaso === "cerrada" && motivo === "CASO_NO_TOMADO") {
    return { estado: "no_aplica", motivo, categoria: "sin_comprobar" };
  }
  if (MOTIVOS_NO_INSTALADO.has(motivo)) return { estado: "no_disponible", motivo, categoria: "no_instalado" };
  if (MOTIVOS_SIN_COMPROBAR.has(motivo)) return { estado: "no_disponible", motivo, categoria: "sin_comprobar" };
  if (MOTIVOS_TEMPORALES.has(motivo)) return { estado: "no_disponible", motivo, categoria: "temporal" };
  return { estado: "no_informado", motivo, categoria: null };
}

// Texto de la línea de recursos. `razones` = mapa motivo→frase (RAZON_NO_AUDIO de AudioTwoWay).
export function textoAudio(info, razones) {
  const razon = (info.motivo && razones && razones[info.motivo]) || "";
  switch (info.estado) {
    case "disponible": return "disponible.";
    case "no_aplica": return "no aplica: el caso está cerrado (no se comprobó el equipo).";
    case "no_disponible":
      if (info.categoria === "no_instalado") return `no configurada para este caso. ${razon}`.trim();
      if (info.categoria === "sin_comprobar") return `no comprobada todavía. ${razon}`.trim();
      return `instalada, pero no disponible ahora. ${razon}`.trim();
    default: return "sin dato comprobado de disponibilidad (no informado).";
  }
}
